import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { DeviceEssService } from '../../../Model/DeviceEss/device-ess.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-device-employee',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule, NgbDatepickerModule, LoaderComponent],
  templateUrl: './device-employee.component.html',
  styleUrl: './device-employee.component.scss'
})
export class DeviceEmployeeComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  DeviceData: any[] = [];
  AllData: any[] = [];
  Data: any[] = [];
  FilterIndex = 0;
  Devicefilter = {
    endPoint: "DeviceESS/employee",
    requestBody: {
      DeviceSerialNo: null,
      CompanyCode: null,
      IsExcel: false,
    },
    httpMethod: "Post"
  }

  Card = {
    Total: 0,
    ImageSync: 0,
    ImageSyncRate: 0 as any,
    ImageUnSync: 0,
    ImageUnSyncRate: 0 as any,
    NotApplicable: 0,
    NotApplicableRate: 0 as any,
    Admin: 0,
    User: 0,
  }

  DeviceInfoCard = {
    status: 0,
    DeviceSerialNo: null,
  }

  UserType = null as any;
  dtoptions: DataTables.Settings = {};
  Sites = [] as any;
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private deviceess: DeviceEssService,
    private route: ActivatedRoute,
    private session: SessionService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.Devicefilter.requestBody.DeviceSerialNo = params['sn']);
    this.Devicefilter.requestBody.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_SiteWiseDeviceDetailsSelect();
    //this.GetDevices();
    this.ESS_AdditionalFillCombo();
    this.GetDeviceDetail();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_SiteWiseDeviceDetailsSelect(IsExcel = false) {
    this.isDisabled = true;
    if (!IsExcel) {
      this.Data = [];
      this.AllData = [];
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      } catch (e) { }
    }

    this.Devicefilter.requestBody.IsExcel = IsExcel;

    this.deviceess.commonDeviceApi(this.Devicefilter).subscribe({
      next: (response) => {
        try {
          if ((!IsExcel && response && response.length > 0) || (IsExcel && response)) {
            if (IsExcel && response.success) {
              window.open(response.path, '_blank', 'noopener noreferrer');
            } else if (!IsExcel) {
              this.Card.Total = response.length;
              this.Card.ImageSync = response.filter((e: any) => e.IsImageSync && e.IsImageSync != null).length
              this.Card.ImageSyncRate = this.Card.ImageSync == 0 ? 0 : ((this.Card.ImageSync * 100) / this.Card.Total).toFixed(2);
              this.Card.ImageUnSync = response.filter((e: any) => !e.IsImageSync && e.IsImageSync != null).length
              this.Card.ImageUnSyncRate = this.Card.ImageUnSync == 0 ? 0 : ((this.Card.ImageSyncRate * 100) / this.Card.Total).toFixed(2);
              this.Card.NotApplicable = response.filter((e: any) => e.IsImageSync == null).length;
              this.Card.NotApplicableRate = this.Card.NotApplicable == 0 ? 0 : ((this.Card.NotApplicable * 100) / this.Card.Total).toFixed(2);
              this.Card.Admin = response.filter((e: any) => e.RollID == 1).length;
              this.Card.User = response.filter((e: any) => e.RollID == 0).length;

              this.AllData = response;
              this.Data = Object.values(response);

              this.AllData.filter(e => e.ImagePath == null || e.ImagePath == '').forEach(element => {
                this.GetProfileImage(element.EmployeeDetailsID)
              });
            }
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          try {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          } catch (e) { }

        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterData(index: number) {
    if (this.FilterIndex == index) {
      this.Data = Object.values(this.AllData);
      this.FilterIndex = 0;
    } else {
      this.FilterIndex = index;
      if (index == 1) {
        this.Data = Object.values(this.AllData);
      } else if (index == 1.1) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.RollID == 1));
      } else if (index == 1.2) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.RollID == 0));
      } else if (index == 2.1) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.IsImageSync));
      } else if (index == 2.2) {
        this.Data = Object.values(this.AllData.filter((e: any) => !e.IsImageSync && e.IsImageSync != null));
      } else if (index == 2.3) {
        this.Data = Object.values(this.AllData.filter((e: any) => e.IsImageSync == null));
      }
    }
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  GetDevices() {
    this.isDisabled = true;
    this.DeviceData = [];
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, BSCode: this.Sites.map((e: any) => e.SiteMasterID).toString() }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.DeviceData = response;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDeviceDetail() {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.DeviceInfoCard.status = response[0].status;
            this.DeviceInfoCard.DeviceSerialNo = response[0].serial_num;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.Data = [];
    this.AllData = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }

    this.Card = {
      Total: 0,
      ImageSync: 0,
      ImageSyncRate: 0 as any,
      ImageUnSync: 0,
      ImageUnSyncRate: 0 as any,
      NotApplicable: 0,
      NotApplicableRate: 0 as any,
      Admin: 0,
      User: 0,
    }
  }

  GetProfileImage(EmployeeDetailsID: number) {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/profileimage", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo, EmployeeDetailsID: EmployeeDetailsID }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response.success && response.image != null && response.image != "") {
            this.AllData.filter(e => e.EmployeeDetailsID == EmployeeDetailsID)[0].Base64 = response.image;
            if (this.Data.filter(e => e.EmployeeDetailsID == EmployeeDetailsID).length > 0) {
              this.Data.filter(e => e.EmployeeDetailsID == EmployeeDetailsID)[0].Base64 = response.image;
            }
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ARCheck(event: any, i: number, IsAll = false) {
    if (IsAll) {
      const ischeck = (event.target as HTMLInputElement).checked;
      this.Data.forEach((e: any) => {
        e.IsCheck = ischeck;
      });
    } else {
      this.Data[i].IsCheck = event.target.checked;
    }
  }

  updateUserType() {
    if (this.UserType != null) {
      if (this.Data.findIndex(e => e.IsCheck) >= 0) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to update checked employee usertype?';
        modalRef.result.then((result: any) => {
          if (result) {
            this.Data.filter(e => e.IsCheck).forEach((e: any) => {
              this.UserTypeupdate(e.EmployeeDetailsID);
            });
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Updated Successfully";
            modalRef.result.then((result: any) => {
              this.ESS_SiteWiseDeviceDetailsSelect();
            });
          }
        });
      } else {
        const modalRef = this.modalService.open(AlertWarningComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = "Please select atleast one check box";
        modalRef.result.then((result: any) => { });
      }
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = "Please select user type";
      modalRef.result.then((result: any) => { });
    }
  }

  UserTypeupdate(EmployeeDetailsID: number) {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/usertype", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo, EmployeeDetailsID: EmployeeDetailsID, RollID: parseInt(this.UserType.toString()) }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          // if (response && response.length > 0) {
          //   this.DeviceInfoCard.status = response[0].status;
          //   this.DeviceInfoCard.DeviceSerialNo = response[0].serial_num;
          // } else {
          //   const modalRef = this.modalService.open(AlertWarningComponent, {
          //     size: 'md',
          //     backdrop: 'static',
          //     centered: true,
          //     windowClass: 'confirmation-modal'
          //   });
          //   modalRef.componentInstance.Message = response.Error_Message;
          //   modalRef.result.then((result: any) => { });
          // }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Sites = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'SW', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.Sites = [...new Map(response.Table1.map((e: any) => ({ SiteMasterID: e.SiteCode, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];

          this.GetDevices()
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
